(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ENCABEZADO"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["barrasmieles"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('barra-mieles-responsive')) {
    customElements.define('barra-mieles-responsive', class extends HTMLElement {
      connectedCallback() {
        clearInterval(this.timer);
        this.timer = setInterval(() => {
          if (document.hidden) return;
          const mensajes = Array.from(this.querySelectorAll('.bm-aviso__mensaje'));
          if (mensajes.length < 2) return;
          const actual = mensajes.findIndex(m => m.classList.contains('activo'));
          const siguiente = (actual + 1) % mensajes.length;
          mensajes.forEach((mensaje, indice) => {
            mensaje.classList.toggle('activo', indice === siguiente);
            mensaje.setAttribute('aria-hidden', String(indice !== siguiente));
          });
        }, 3000);
      }
      disconnectedCallback() {
        clearInterval(this.timer);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["inventory-tab"] && !Shopify.designMode) return;
  try {
    
  const injectInventoryBar = () => {
    const wrapper = document.querySelector('#section-inventory-bar-hidden')

    const productInfo = document.querySelector('product-info')
    const buttonsWrapper = productInfo.querySelector('.product-form__buttons')
    
    buttonsWrapper.insertAdjacentHTML('beforebegin', `
      ${wrapper.innerHTML}
    `)  

    function animateProgressBar () {
      const progressBar = productInfo.querySelector('#section-inventory-bar .progress-bar')

      setTimeout(() => {
        progressBar.style.width = progressBar.dataset.width
      }, 250)
    }
    animateProgressBar()

    async function handleVariantChange () {
      const inventoryBar = productInfo.querySelector('#section-inventory-bar')

      inventoryBar.style.opacity = '.25' 

      await new Promise(r => setTimeout(r, 200)) 

      const respoonse = await fetch(window.location.href)
      const text = await respoonse.text()
      const newDocument = new DOMParser().parseFromString(text, 'text/html')

      inventoryBar.replaceWith(newDocument.querySelector('#section-inventory-bar'))
      animateProgressBar()
    }

    productInfo.querySelectorAll('variant-selects input').forEach(input => {
      input.addEventListener('change', () => {
        handleVariantChange()
      })
    })

    productInfo.querySelectorAll('variant-selects select').forEach(select => {
      select.addEventListener('change', () => { 
        handleVariantChange()
      })
    })
  }
  injectInventoryBar()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class LookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.section-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.section-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('section-lookbook', LookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["newsletter-popup"] && !Shopify.designMode) return;
  try {
     
  if (Shopify.designMode) return

  function createCookie (name, value, days) {
    let date, expires
    if (days) {
      date = new Date()
      date.setDate(date.getDate() + days)
      expires = '; expires=' + date.toUTCString()
    } else {
      expires = ''
    }
    document.cookie = name + '=' + value + expires + '; path=/'
  }

  const dialog = document.querySelector('#section-newsletter-dialog')

  dialog.addEventListener('click', (event) => {
    const withinBoundaries = event.composedPath().includes(dialog.querySelector('.section-dialog-inner'))

    if (!withinBoundaries) {
      dialog.close() 
    }
  })

  dialog.querySelector('data-dialog-close')?.addEventListener('click', (event) => {
    event.preventDefault()
    dialog.close()
  })

  // Show the dialog if url contains (www.mystore.com/?section-newsletter-popup)
  if (window.location.href.includes('section-newsletter-popup')) {
    dialog.showModal() 
    return
  }

  if (document.cookie.indexOf('section-newsletter-popup') > -1) {
    return
  }

  (async () => {
    
    await new Promise(resolve => setTimeout(resolve, Number(dialog.dataset.configDelay) * 1000))

    createCookie('section-newsletter-popup', true, Number(dialog.dataset.configDaysToWait))

    dialog.showModal()
  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["refesreales"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('real-reviews-carousel')) {
    customElements.define('real-reviews-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.eventsController) this.eventsController.abort();
        this.eventsController = new AbortController();
        const videoListenerOptions = { signal: this.eventsController.signal };
        this.querySelectorAll('[data-play-video]').forEach((button) => {
          const media = button.closest('.referencias-reales__media');
          const video = media.querySelector('video');
          const error = media.querySelector('[data-video-error]');
          if (!video) return;
          button.hidden = !video.paused;
          const showError = () => { error.hidden = false; button.hidden = false; };
          button.addEventListener('click', async () => {
            error.hidden = true;
            video.controls = true;
            try {
              await video.play();
            } catch (failure) {
              showError();
            }
          }, videoListenerOptions);
          video.addEventListener('play', () => {
            button.hidden = true;
            error.hidden = true;
            this.querySelectorAll('video').forEach((other) => {
              if (other !== video) other.pause();
            });
          }, videoListenerOptions);
          video.addEventListener('pause', () => { button.hidden = false; }, videoListenerOptions);
          video.addEventListener('ended', () => { button.hidden = false; }, videoListenerOptions);
          video.addEventListener('error', showError, videoListenerOptions);
        });
        this.viewport = this.querySelector('[data-viewport]');
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        this.dialog = this.querySelector('[data-full-dialog]');
        this.dialogImage = this.querySelector('[data-dialog-image]');

        if (!this.viewport || !this.previousButton || !this.nextButton) return;

        this.previousButton.addEventListener('click', () => this.move(-1));
        this.nextButton.addEventListener('click', () => this.move(1));
        this.viewport.addEventListener('scroll', () => this.updateButtons(), { passive: true });
        this.resizeObserver = new ResizeObserver(() => this.updateButtons());
        this.resizeObserver.observe(this.viewport);
        this.querySelectorAll('[data-open-full]').forEach((button) => {
          button.addEventListener('click', () => this.openImage(button));
        });
        this.querySelector('[data-close-full]')?.addEventListener('click', () => this.closeImage());
        this.dialog?.addEventListener('click', (event) => {
          if (event.target === this.dialog) this.closeImage();
        });
        this.dialog?.addEventListener('close', () => {
          if (this.dialogImage) this.dialogImage.src = '';
        });
        this.updateButtons();
      }

      disconnectedCallback() {
        this.eventsController?.abort();
        this.querySelectorAll('video').forEach((video) => video.pause());
        if (this.resizeObserver) this.resizeObserver.disconnect();
      }

      move(direction) {
        const card = this.querySelector('.referencias-reales__card');
        const track = this.querySelector('.referencias-reales__track');
        if (!card || !track) return;

        const gap = Number.parseFloat(getComputedStyle(track).columnGap) || 0;
        this.viewport.scrollBy({ left: direction * (card.getBoundingClientRect().width + gap), behavior: 'smooth' });
      }

      openImage(button) {
        if (!this.dialog || !this.dialogImage) return;
        this.dialogImage.src = button.dataset.fullImage;
        this.dialogImage.alt = button.dataset.fullAlt || 'Referencia real de cliente';
        this.dialog.showModal();
      }

      closeImage() {
        if (this.dialog?.open) this.dialog.close();
      }

      updateButtons() {
        const maxScroll = this.viewport.scrollWidth - this.viewport.clientWidth;
        this.previousButton.disabled = this.viewport.scrollLeft <= 2;
        this.nextButton.disabled = this.viewport.scrollLeft >= maxScroll - 2;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
